import { useTranslation } from 'react-i18next'

import { useDateLocale, useTimeZone } from '../../../hooks'
import {
  CalendarGridCard,
  CalendarGridCardField,
  CalendarGridItemCardDefault,
  getCalendarGridItemCardDayLabel,
} from '../../CalendarGrid'

import { QA_NAME_CALENDAR_ITEM_CARD } from './CalendarItemCard.constants'
import { CalendarItemCardDetails } from './CalendarItemCardDetails'
import { CalendarItemCardSteps } from './CalendarItemCardSteps'
import { CalendarItemCardTags } from './CalendarItemCardTags'

function CalendarItemCard({ item, onClose }) {
  const { card, isAllDay, isArchived, isDue, kind, url } = item

  const { t } = useTranslation()

  const locale = useDateLocale()
  const timezone = useTimeZone()

  return card ? (
    <CalendarGridCard
      HeaderContent={CalendarItemCardTags}
      headerContentProps={{ isAllDay, isArchived, isDue, kind }}
      qaName={QA_NAME_CALENDAR_ITEM_CARD}
      title={card.title}
      titleUrl={url}
      onClose={onClose}
    >
      <CalendarItemCardDetails address={card.address} people={card.people} />
      {card.steps ? (
        <CalendarItemCardSteps steps={card.steps} onClose={onClose} />
      ) : null}
      <CalendarGridCardField
        label={t('Calendar.DateLabelKey')}
        value={getCalendarGridItemCardDayLabel({ item, locale, timezone })}
      />
    </CalendarGridCard>
  ) : (
    <CalendarGridItemCardDefault item={item} onClose={onClose} />
  )
}

export default CalendarItemCard
